import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { ConsentBanner as BaseConsentBanner } from '@singtel-main/widgets';
import { translation as t } from '../../helpers/translation';
import {
  ConsentBannerProps,
  ConsentBannerStaticQueryData,
} from './ConsentBanner.types';

export const ConsentBanner = ({ showAppBanner }: ConsentBannerProps) => {
  return (
    <StaticQuery
      query={graphql`
        {
          consentBanner {
            cookieName
            expireDays
            text
            openApp {
              appUrl {
                ios
                android
              }
              text
              imgUrl
            }
          }
        }
      `}
      render={(data: ConsentBannerStaticQueryData) => {
        const consentBannerData = { ...data.consentBanner };
        consentBannerData.openApp = {
          ...consentBannerData.openApp,
          enabled: showAppBanner,
          buttonLabel: t('OPEN') as string,
        };

        return (
          <BaseConsentBanner
            {...consentBannerData}
            hostName={process.env.GATSBY_HOSTNAME}
          />
        );
      }}
    />
  );
};

export default ConsentBanner;
